// extracted by mini-css-extract-plugin
module.exports = {"viewAll":"common_viewAll__31JsP","head":"common_head__gaHhc","name":"common_name__uBZOs","viewAllTop":"common_viewAllTop__VRNRB","footer":"common_footer__MMjiX"};